module.exports = __webpack_public_path__ + "static/media/logo-leclerc.9e678aaa.svg";